import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=2e27614b"
import script from "./leftMenu.vue?vue&type=script&lang=js"
export * from "./leftMenu.vue?vue&type=script&lang=js"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=2e27614b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports